import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

import CustomSpeedDialAction from "~/libs/material-ui/CustomSpeedDialAction";
import useOutsideClick from "~/hooks/useOutsideClick";

const StyledCustomSpeedDialAction = styled(CustomSpeedDialAction)(({ theme, ...props }) => {
  let baseStyles = {
    marginTop: 0,
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };

  if (props.markedNote) {
    baseStyles = {
      ...baseStyles,
      backgroundColor: theme.palette.mborange[1],
      color: "white",
      "&:hover": {
        backgroundColor: theme.palette.mborange[0]
      }
    };
  } else if (props.markedPresentation) {
    baseStyles = {
      ...baseStyles,
      backgroundColor: theme.palette.prblue[1],
      color: "white",
      "&:hover": {
        backgroundColor: theme.palette.prblue[0]
      }
    };
  }

  return baseStyles;
});

const StyledSpeedDial = styled(SpeedDial)(({ theme, ...props }) => ({
  position: "absolute",
  "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
    bottom: theme.spacing(props.positionSpacing),
    right: props.istTitel ? "unset" : theme.spacing(props.positionSpacing),
    left: props.istTitel ? "44px" : "unset"
  },
  "& [class*='MuiSvgIcon-root']": {
    fontSize: theme.typography.pxToRem(26)
  },
  "@media print": {
    display: "none"
  },
  "& .MuiSpeedDial-fab": {
    backgroundColor: theme.palette.blue[0],
    "&:hover": {
      backgroundColor: theme.palette.blue[1]
    },
    ...(props.istTitel ? { width: "42px" } : {}),
    ...(props.istTitel ? { height: "42px" } : {})
  },
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function QuickDial({ classes, actions, istTitel, positionSpacing }) {
  const [isOpen, setIsOpen] = useState(false);
  const dialRef = useRef(null);

  useOutsideClick(dialRef, onOutsideClick);

  function onOutsideClick() {
    setIsOpen(false);
  }

  function onOpen(event, reason) {
    if (reason === "toggle") {
      setIsOpen(true);
    } else {
      event.preventDefault();
    }
  }

  function onClose(event, reason) {
    if (reason === "toggle") {
      setIsOpen(false);
    } else {
      event.preventDefault();
    }
  }

  function onAction(action) {
    if (action.closeQuickdialOnAction) {
      return event => {
        setIsOpen(false);
        action.handler(event);
      };
    }
    return event => action.handler(event);
  }

  return (
    <Tooltip
      title={!isOpen && "Aktionsmenü öffnen"}
      placement="left-end"
      // classes={getTooltipClasses()}
      slotProps={{
        popper: {
          style: {
            display: isOpen ? "none" : "unset"
          }
        }
      }}
      classes={{
        tooltip: "custom-mui-fab-tooltip"
      }}
    >
      <StyledSpeedDial
        ref={dialRef}
        ariaLabel="Menü"
        // className={classes.dial}
        icon={<SpeedDialIcon />}
        onOpen={onOpen}
        onClose={onClose}
        open={isOpen}
        direction="up"
        aria-orientation="vertical"
        // classes={getSpeedDialClasses()}
        istTitel={istTitel}
        positionSpacing={positionSpacing}
      >
        {actions.map(action => {
          return (
            action && (
              <StyledCustomSpeedDialAction
                key={action.name}
                title={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                onClick={onAction(action)}
                // classes={getSpeedDialActionClasses(action)}
                tooltipOpen
                markedNote={action.markedNote}
                markedPresentation={action.markedPresentation}
                TooltipClasses={{
                  tooltip: "custom-mui-action-fab-tooltip"
                }}
              />
            )
          );
        })}
      </StyledSpeedDial>
    </Tooltip>
  );
}

QuickDial.propTypes = {
  classes: PropTypes.object,
  actions: PropTypes.array.isRequired,
  // eslint-disable-next-line react-redux/no-unused-prop-types
  positionSpacing: PropTypes.number,
  istTitel: PropTypes.bool
};

QuickDial.defaultProps = {
  actions: [],
  positionSpacing: 2
};

export default QuickDial;
